export const GET_COURSES = "GET_COURSES";
export const GET_COURSE_BY_ID = "GET_COURSE_BY_ID";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const CREATE_COURSE = "CREATE_COURSE";
